import { useTranslation } from 'next-i18next';
import { FC, Fragment } from 'react';

import { TAG_CLOSE_ARIA_LABEL } from '@/constants/global';
import { Tag, TagAppearance, TagColorsTypes } from '@proprioo/salatim';

import { LocationState } from '../interfaces';
import { getLocationNames } from '../utils';

export type TagsProps = {
  agentIds: number[];
  locationState: LocationState[];
  updateLocations(locationState: LocationState[]): void;
};

const Tags: FC<TagsProps> = ({ agentIds, locationState, updateLocations }) => {
  const { t } = useTranslation();
  const locationNames = getLocationNames(locationState);

  return (
    <Fragment>
      {Boolean(agentIds.length) && (
        <Tag
          appearance={TagAppearance.BUSINESS}
          closeAriaLabel={t(TAG_CLOSE_ARIA_LABEL)}
          color={TagColorsTypes.GREY_LIGHT}
          labels={[t('myZones')]}
          onClose={() => updateLocations([])}
        />
      )}
      {locationNames.map((locationName, tagIndex) => (
        <Tag
          appearance={TagAppearance.BUSINESS}
          closeAriaLabel={t(TAG_CLOSE_ARIA_LABEL)}
          color={TagColorsTypes.GREY_LIGHT}
          dataTest={`tag-${locationName}`}
          key={tagIndex}
          labels={[locationName]}
          onClose={() =>
            updateLocations(
              locationState.filter(({ name }) => name !== locationName)
            )
          }
        />
      ))}
    </Fragment>
  );
};

export default Tags;
